var map = {
	"./lunr.da": 67,
	"./lunr.da.js": 67,
	"./lunr.de": 68,
	"./lunr.de.js": 68,
	"./lunr.du": 69,
	"./lunr.du.js": 69,
	"./lunr.es": 70,
	"./lunr.es.js": 70,
	"./lunr.fi": 71,
	"./lunr.fi.js": 71,
	"./lunr.fr": 72,
	"./lunr.fr.js": 72,
	"./lunr.hu": 73,
	"./lunr.hu.js": 73,
	"./lunr.it": 74,
	"./lunr.it.js": 74,
	"./lunr.ja": 51,
	"./lunr.ja.js": 51,
	"./lunr.jp": 75,
	"./lunr.jp.js": 75,
	"./lunr.multi": 76,
	"./lunr.multi.js": 76,
	"./lunr.nl": 77,
	"./lunr.nl.js": 77,
	"./lunr.no": 78,
	"./lunr.no.js": 78,
	"./lunr.pt": 79,
	"./lunr.pt.js": 79,
	"./lunr.ro": 80,
	"./lunr.ro.js": 80,
	"./lunr.ru": 81,
	"./lunr.ru.js": 81,
	"./lunr.stemmer.support": 50,
	"./lunr.stemmer.support.js": 50,
	"./lunr.sv": 82,
	"./lunr.sv.js": 82,
	"./lunr.th": 83,
	"./lunr.th.js": 83,
	"./lunr.tr": 84,
	"./lunr.tr.js": 84
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 131;